import { toString as toString_1, Union, Record } from "./fable_modules/fable-library-js.4.17.0/Types.js";
import { PreOpen_PreOpenMeta_$reflection, Analytics_ReviewEntry_$reflection } from "./Shared/ApiDataTypes.js";
import { obj_type, union_type, record_type, string_type, bool_type, option_type, array_type } from "./fable_modules/fable-library-js.4.17.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.17.0/Result.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { singleton as singleton_1, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.17.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { DataServerBaseUrl } from "./Components/Constants.js";
import { fromString } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { createObj, uncurry2 } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { createElement } from "react";
import React from "react";
import { DefaultBorder } from "./Components/Design.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.17.0/Seq.js";
import { LoadingIndicator_skeleton, Tooltip_tooltipHeader } from "./Components/Components.js";
import { map as map_1, mapIndexed } from "./fable_modules/fable-library-js.4.17.0/Array.js";
import { month, day, dayOfWeek, parse } from "./fable_modules/fable-library-js.4.17.0/Date.js";
import { Time_monthToString, Time_dayOfWeekToString } from "./Components/Utils.js";
import { PreOpenSubModal, linkToAll } from "./PreOpenSummary/PreOpenSummary.js";
import { StockRating__ToColorCode, StockRating_FromInt_Z524259A4 } from "./Shared/Shared.js";
import { useReact_useEffectOnce_3A5B6456, useReact_useReducer_2B9E6EA0 } from "./fable_modules/Feliz.2.7.0/React.fs.js";
import { Feed } from "./Feed.js";
import { SquareAd } from "./Components/Ads.js";

class Model extends Record {
    constructor(LatestReviews, LatestPreOpen, ShowSubInfo, ErrorMsg) {
        super();
        this.LatestReviews = LatestReviews;
        this.LatestPreOpen = LatestPreOpen;
        this.ShowSubInfo = ShowSubInfo;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Investfora.Home.Model", [], Model, () => [["LatestReviews", option_type(array_type(Analytics_ReviewEntry_$reflection()))], ["LatestPreOpen", option_type(array_type(PreOpen_PreOpenMeta_$reflection()))], ["ShowSubInfo", bool_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LatestReviewsResponse", "LatestPreOpenResponse", "ToggleShowSubInfo", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Investfora.Home.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Analytics_ReviewEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Analytics_ReviewEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(PreOpen_PreOpenMeta_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(PreOpen_PreOpenMeta_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", bool_type]], []]);
}

function init() {
    return new Model(undefined, undefined, false, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1: {
            const res_1 = msg.fields[0];
            if (res_1.tag === 0) {
                return new Model(model.LatestReviews, res_1.fields[0], model.ShowSubInfo, model.ErrorMsg);
            }
            else {
                return model;
            }
        }
        case 2:
            return new Model(model.LatestReviews, model.LatestPreOpen, msg.fields[0], model.ErrorMsg);
        case 3:
            return new Model(model.LatestReviews, model.LatestPreOpen, model.ShowSubInfo, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 0) {
                return new Model(res.fields[0], model.LatestPreOpen, model.ShowSubInfo, model.ErrorMsg);
            }
            else {
                return model;
            }
        }
    }
}

/**
 * Fetches the latest published reviews
 */
export function fetchLatestReviews(callback) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let decoder, data_1, caseStrategy_2, extra_2;
        return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Analytics_ReviewEntry_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}${"/api/asset/mostrecent"}`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Analytics_ReviewEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))).then((_arg_2) => {
            callback(_arg_2);
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

/**
 * Fetches the latest pre-open entries
 */
export function fetchLatestPreOpens(callback) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let decoder, data_1, caseStrategy_2, extra_2;
        return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(PreOpen_PreOpenMeta_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/pre-open/latest", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(PreOpen_PreOpenMeta_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))).then((_arg_2) => {
            callback(_arg_2);
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

function boxHolder(children) {
    return createElement("div", {
        style: createObj(ofArray([["display", "flex"], ["flexDirection", "column"], ["width", 100 + "%"], ["maxWidth", 450], ["backgroundColor", "#FFFFFF"], DefaultBorder, ["borderRadius", 5]])),
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

function drawPreOpens(x$0027, toggleSubInfo) {
    return boxHolder(toList(delay(() => append(singleton(Tooltip_tooltipHeader("Siste \"Før børsåpning\"-artikler", "De nyligste publiserte artiklene av vår \"Før børsåpning\"-markedsoppdatering. Publiseres hver børsdag.")), delay(() => {
        let matchValue, x, elems_2;
        return append((matchValue = x$0027, (matchValue != null) ? ((x = matchValue, singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            margin: 5,
            flexGrow: 1,
        }], (elems_2 = mapIndexed((i, y) => {
            let dateString;
            try {
                const dt = parse(y.Date);
                dateString = (`${Time_dayOfWeekToString(dayOfWeek(dt))} ${day(dt)} ${Time_monthToString(month(dt))}`);
            }
            catch (matchValue_1) {
                dateString = y.Date;
            }
            return createElement("div", createObj(toList(delay(() => append(singleton(["style", createObj(toList(delay(() => append(singleton(["backgroundColor", ((i % 2) === 0) ? "var(--bg-main)" : "#fff"]), delay(() => append(singleton(["padding", ((3 + "px ") + 5) + "px"]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["justifyContent", "space-between"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => (!y.HasAccess ? singleton(["cursor", "pointer"]) : empty_1()))))))))))))))]), delay(() => append(!y.HasAccess ? singleton(["onClick", (_arg) => {
                toggleSubInfo();
            }]) : empty_1(), delay(() => {
                let elems_1;
                return singleton((elems_1 = toList(delay(() => {
                    let elems;
                    return y.HasAccess ? singleton(createElement("a", createObj(ofArray([["style", {}], ["href", `/pre-open/${y.Date}`], (elems = [createElement("span", {
                        children: [dateString],
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))) : append(singleton(createElement("span", {
                        style: {
                            color: "var(--text-dim)",
                        },
                        children: dateString,
                    })), delay(() => singleton(createElement("span", {
                        style: {
                            color: "var(--text-dim)",
                            fontStyle: "italic",
                            userSelect: "none",
                        },
                        children: "Krever aksje.io+",
                    }))));
                })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))]));
            }))))))));
        }, x), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))))) : singleton(LoadingIndicator_skeleton(ofArray([["width", 100 + "%"], ["minHeight", 160]])))), delay(() => {
            let elems_3;
            return singleton(createElement("div", createObj(ofArray([["style", {
                paddingLeft: 7,
            }], (elems_3 = [linkToAll()], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]))));
        }));
    })))));
}

export function drawReviews(x$0027) {
    return boxHolder(toList(delay(() => append(singleton(Tooltip_tooltipHeader("Siste analyser fra brukere", "De nyligste analysene publisert av aksje.io brukere")), delay(() => {
        let elems_4;
        const matchValue = x$0027;
        return (matchValue != null) ? singleton(createElement("table", createObj(singleton_1((elems_4 = map_1((r) => {
            let elems_3, elems_1, elems, elems_2, children;
            const rating = StockRating_FromInt_Z524259A4(r.Rating);
            return createElement("tr", createObj(ofArray([["style", {}], (elems_3 = [createElement("td", createObj(singleton_1((elems_1 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
            }], (elems = [createElement("i", {
                className: (rating.tag === 1) ? "fas fa-arrow-circle-right" : ((rating.tag === 2) ? "fas fa-arrow-circle-right" : ((rating.tag === 3) ? "fas fa-arrow-circle-right" : ((rating.tag === 4) ? "fas fa-arrow-circle-down" : "fas fa-arrow-circle-up"))),
                style: {
                    color: StockRating__ToColorCode(rating),
                    marginRight: 5,
                    fontSize: 1 + "rem",
                },
            }), createElement("a", {
                style: {},
                href: `/post?src=rv&sid=${r.ReviewId}`,
                children: toString_1(rating),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])))), createElement("td", createObj(ofArray([["style", {
                fontWeight: "bold",
            }], (elems_2 = [createElement("a", {
                style: {
                    userSelect: "none",
                },
                href: `/stock/${r.MarketTicker}/${r.AssetTicker}`,
                children: r.AssetTicker,
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), (children = singleton_1(createElement("a", {
                style: {
                    userSelect: "none",
                },
                href: `/user/${r.Username}`,
                children: r.Username,
            })), createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
        }, matchValue), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))]))))) : singleton(LoadingIndicator_skeleton(ofArray([["width", 100 + "%"], ["minHeight", 160]])));
    })))));
}

export function Home() {
    let elems_1, elems;
    const patternInput = useReact_useReducer_2B9E6EA0(update, init());
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    useReact_useEffectOnce_3A5B6456(() => {
        fetchLatestReviews((arg) => {
            dispatch(new Message(0, [arg]));
        });
        fetchLatestPreOpens((arg_1) => {
            dispatch(new Message(1, [arg_1]));
        });
    });
    return createElement("div", createObj(ofArray([["className", "home-holder"], (elems_1 = [createElement(Feed, null), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 100 + "%",
        maxWidth: 450,
        gap: (((1 + "vw") + " ") + 0) + "px",
    }], (elems = toList(delay(() => append(model_1.ShowSubInfo ? singleton(PreOpenSubModal(() => {
        dispatch(new Message(2, [false]));
    })) : empty_1(), delay(() => append(singleton(drawPreOpens(model_1.LatestPreOpen, () => {
        dispatch(new Message(2, [!model_1.ShowSubInfo]));
    })), delay(() => append(singleton(drawReviews(model_1.LatestReviews)), delay(() => singleton(createElement("div", {
        style: {
            width: 100 + "%",
        },
        children: createElement(SquareAd, null),
    })))))))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
}

